/**
 * Sidebar — left navigation rail in chat-active mode (Task 069). Lives in the
 * left grid track reserved by Task 068, so it does not push the centered
 * reading column off the viewport center.
 *
 * Intentionally small: New chat + About + a GreenScript attribution. Pure
 * presentational — the only behavior is the New chat handler passed from App
 * (same `handleNewChat` the topbar uses). No state, no Effects.
 *
 * Visibility is CSS-driven: `.sidebar` is `display: none` below the desktop
 * breakpoint, where the topbar's "Nueva" button carries the New chat action
 * instead — so this renders unconditionally and the media query decides.
 */
import type { Strings } from "../strings";
import { connectionsPath, caminosPath, softNavigate } from "../corpus/use-corpus-route";
import { BowSigil } from "./Wordmark";

export interface SidebarProps {
  strings: Strings;
  onNewChat: () => void;
  onAbout: () => void;
  /** Task 189: open the Corpus Reader / Biblioteca (shown above About). */
  onCorpus: () => void;
}

export function Sidebar(props: SidebarProps): JSX.Element {
  const { strings, onNewChat, onAbout, onCorpus } = props;
  return (
    <aside className="sidebar" aria-label={strings.appTitle} data-testid="sidebar">
      <nav className="sidebar__nav">
        <button type="button" className="sidebar__item" onClick={onNewChat}>
          <BowSigil className="sidebar__glyph" />
          {strings.navNewChat}
        </button>
        {/* Task 189: Biblioteca / Corpus Reader — above About per Diego. */}
        <button type="button" className="sidebar__item" onClick={onCorpus}>
          <BowSigil className="sidebar__glyph" />
          {strings.navBiblioteca}
        </button>
        {/* Task 224: Conexiones — the third learning mode, peer of Biblioteca. */}
        <button
          type="button"
          className="sidebar__item"
          onClick={() => softNavigate(connectionsPath())}
        >
          <BowSigil className="sidebar__glyph" />
          {strings.navConexiones}
        </button>
        {/* Task 227: Caminos — the fourth learning mode, guided study-flights. */}
        <button
          type="button"
          className="sidebar__item"
          onClick={() => softNavigate(caminosPath())}
        >
          <BowSigil className="sidebar__glyph" />
          {strings.navCaminos}
        </button>
        <button type="button" className="sidebar__item" onClick={onAbout}>
          {strings.navAbout}
        </button>
      </nav>
      <div className="sidebar__links">
        {/* Task 174: official congregation site is the PRIMARY destination;
            GreenScript stays as a smaller, secondary developer credit. */}
        <a
          className="sidebar__official"
          href="https://losdelcamino.net/"
          target="_blank"
          rel="noopener noreferrer"
        >
          {strings.navOfficialSite}
        </a>
        <a
          className="sidebar__credit"
          href="https://greenscript.dev"
          target="_blank"
          rel="noopener noreferrer"
        >
          {strings.navDevelopedBy}
        </a>
      </div>
    </aside>
  );
}
